import script from "./Lottie.vue?vue&type=script&setup=true&lang=js"
export * from "./Lottie.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__